import { useState, useEffect } from 'react';
import { checkAccess } from '../utils';

function useCheckRole(role) {
  const [ canUse, setCanUse ] = useState(false);

  useEffect(() => {
    checkAccess(role).then(res => setCanUse(res)).catch(() => setCanUse(false));
  }, [ role ]);

  return canUse;
}

export default useCheckRole;